import { loadStripe } from '@stripe/stripe-js';
import appSetting from './appSetting';

const apiKey = appSetting.REACT_APP_STRIPE_KEY;
const stripePromise = loadStripe(apiKey);

export default stripePromise;
